import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

class DataReferensi {
  async getDataDokter() {
    let dt: any;
    await http.getData(`/ref-dokter`)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Data Referensi Dokter")
      });
    return dt;
  }

  async getDataUnit() {
    let dt: any;
    await http.getData(`/ref-bed`)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Data Referensi Unit/Bangsal")
      });
    return dt;
  }

  async getDataUnitAll() {
    let dt: any;
    await http.getData(`/ref-unit`)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Data Referensi Unit All")
      });
    return dt;
  }

  async getDataKelas() {
    let dt: any;
    await http.getData(`/ref-bed-kelas`)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Data Referensi Kelas")
      });
    return dt;
  }

  async getDataStatus() {
    let dt: any;
    await http.getData(`/ref-bed-status`)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Data Referensi Status Bed/Kamar")
      });
    return dt;
  }

  async getDataBedKosongByUnit(unitID) {
    let dt: any;
    await http.getData(`/unit/${unitID}/bed-kosong`)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Data Referensi Bed Kosong by Unit")
      });
    return dt;
  }

  async postDataKey(key) {
    let dt: any;
    await http.postData(`/booking-bypass`, {
      key: key,
    })
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
        ErrorAlert.showSnackAlert(e, "Booking bypass (kode)")
      });
    return dt;
  }
}

export default new DataReferensi();
